import { render } from "./UpdateAddressOfNeiOrder.vue?vue&type=template&id=4a338a9c&scoped=true"
import script from "./UpdateAddressOfNeiOrder.vue?vue&type=script&lang=ts"
export * from "./UpdateAddressOfNeiOrder.vue?vue&type=script&lang=ts"

import "./UpdateAddressOfNeiOrder.vue?vue&type=style&index=0&id=4a338a9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a338a9c"

export default script